import DefaultScreen from "@components/Global/DefaultScreenView";
import SwipeableRobot from "@components/RobotHelper/SwipeableRobot";
import { Title } from "@constants/Themed";
import { Box, Button, Step, StepContent, StepLabel, Stepper, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useWindowDimensions, View } from "react-native";
import { Text } from "@constants/Themed";
import GenerateSchemaForm from "@hooks/generateSchemaForm";
import LottieView from "@utils/lottieAnimation";
import styles from "@stylesheet";
import apis from "@api/api";
import ErrorBoundary from "@utils/ErrorBoundary";


const steps = [
  { label: 'Business Idea & Sustainability Focus', description: 'What is your business idea and how does it contribute to a sustainable future?' },
  { label: 'Business Plan', description: 'What is your business plan and how do you plan to execute it?' },
  { label: 'Legal Structure and Registration', description: 'What is the legal structure of your business and how do you plan to register it?' },
  { label: 'Funding Your Sustainable Startup', description: 'How do you plan to fund your sustainable startup?' },
  { label: 'Digital Presence', description: 'How do you plan to establish a digital presence for your startup?' },
  { label: 'Marketing and Promotion', description: 'How do you plan to market and promote your startup?' },
  { label: 'Company Culture and Team Building', description: 'What is the company culture of your startup and how do you plan to build your team?' },
]

const StartupBuilder = () => {
  const [activeStep, setActiveStep] = React.useState(0);
  const [businessSchemas, setBusinessSchemas] = React.useState([]);
  const [filledSchemas, setFilledSchemas] = React.useState([]);
  const windowDimensions = useWindowDimensions();

  useEffect(() => {
    // Fetch business schemas
    const getSchemas = async () => await apis.getStartupSchemas().then((res) => {
      console.log(res);
      setBusinessSchemas(res);
    })
    getSchemas();
  }, [])

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <DefaultScreen scrollDisabled noMargin style={{ margin: -60 }} >
      <View style={[styles.background, { position: 'absolute', width: '130%', overflow: 'hidden', minHeight: windowDimensions.height + 350 }]}>
        <LottieView source={require('@assets/animations/backgroundLottie.json')} style={{ minWidth: windowDimensions.width < 1020 ? "120%" : "100%" }} autoPlay loop={true}></LottieView>
      </View>
      <View style={{ flex: 1, padding: 80, paddingLeft: 120, flexDirection: "row" }}>
        <View style={{ flex: 1, paddingVertical: "15%" }}>
          <Title style={{ textShadowRadius: 20, fontSize: 36, color: "white", top: 10, position: "absolute" }}>Startup Builder</Title>
          <Stepper orientation="vertical" style={{ alignSelf: "stretch" }} activeStep={activeStep} >
            {steps.map((step, index) => (
              <Step key={step.label}>
                <StepLabel
                  optional={
                    index === steps.length - 1 ? (
                      <Typography variant="caption">Last step</Typography>
                    ) : null
                  }
                >
                  {step.label}
                </StepLabel>
                <StepContent>
                  <Typography>{step.description}</Typography>
                  <Box sx={{ mb: 2 }}>
                    <Button
                      variant="contained"
                      onClick={handleNext}
                      sx={{ mt: 1, mr: 1 }}
                    >
                      {index === steps.length - 1 ? 'Finish' : 'Continue'}
                    </Button>
                    <Button
                      disabled={index === 0}
                      onClick={handleBack}
                      sx={{ mt: 1, mr: 1 }}
                    >
                      Back
                    </Button>
                  </Box>
                </StepContent>
              </Step>
            ))}
          </Stepper>
        </View>
        <View style={{ flex: 4, minWidth: "70%" }}>
          <GenerateSchemaForm hideButton schema={businessSchemas[activeStep]} />
        </View>
      </View>
      <SwipeableRobot style={{ position: "absolute", bottom: 30 }} textHelp={["Let me help you build your startup!", "Fill in the information and we will guide you through the process"]} />
    </DefaultScreen>
  )
};
export default StartupBuilder;